export const navItems = [
  {
    name: "Home",
    slug: "home",
    path: "/",
  },
  {
    name: "Shop",
    slug: "shop",
    path: "/shop",
  },
  {
    name: "About",
    slug: "about",
    path: "/about",
  },
  {
    name: "Booking",
    slug: "bookings",
    path: "/bookings",
  },
  {
    name: "Contact",
    slug: "contact",
    path: "/contact",
  },
];
export const navOthers = [
  {
    name: "Shop",
    slug: "shop",
    path: "/shop",
  },
  {
    name: "About",
    slug: "about",
    path: "/about",
  },
  {
    name: "Booking",
    slug: "bookings",
    path: "/bookings",
  },
  {
    name: "Contact",
    slug: "contact",
    path: "/contact",
  },
];
export const navHelp = [
  {
    name: "Deluxe Collection",
    slug: "deluxe-collection",
    path: "/shop/deluxe-collection",
  },
  {
    name: "Best Seller",
    slug: "best-seller",
    path: "/shop/best-seller",
  },
  {
    name: "Recently Added",
    slug: "recently-added",
    path: "/shop/recently-added",
  },
];

export const SBD_SERVICES = [
  {
    category: "Hair Installations",
    description:
      "Professional hair installation services including frontal and closure installs, wig creation, styling, and reinstall services tailored for a polished and long lasting finish.",
    services: [
      { name: "Frontal Half Up Half Down", price: 100 },
      { name: "Lace Frontal Install", price: 110 },
      { name: "Lace Closure Install", price: 95 },
      { name: "Lace Frontal Wig With Install", price: 150 },
      { name: "Lace Closure Wig With Install", price: 120 },
      { name: "Wig Styling", price: 55 },
      { name: "Frontal Ponytail", price: 115 },
      { name: "Frontal Bun", price: 100 },
      { name: "Wig Re Install", price: 95 },
    ],
  },
  {
    category: "Ponytails",
    description:
      "Sleek and stylish ponytail services designed to suit different preferences, including frontal, natural, and 360 installations for a clean and elegant look.",
    services: [
      { name: "Frontal Ponytail", price: 85 },
      { name: "Two Frontal Ponytail", price: 85 },
      { name: "Natural Ponytail", price: 85 },
      { name: "360 Installation", price: 80 },
    ],
  },
  {
    category: "Bridal Styling",
    description:
      "Luxury bridal hair styling services curated for weddings and special occasions, with options available for both London and destination bookings.",
    services: [
      { name: "London Service", price: 350 },
      { name: "Outside London Service", price: 500 },
    ],
  },

  {
    category: "Wig Revamps",
    description:
      "Wig refresh and restyling services designed to restore, redefine, and elevate wigs through professional straightening, curling, and styling techniques.",
    services: [
      { name: "Revamping Straight Hair", price: 100 },
      { name: "Revamping Curly Hair", price: 120 },
      { name: "Styling Straight Hair", price: 100 },
      { name: "Styling Curly Hair", price: 120 },
    ],
  },

  {
    category: "SBD 1:1 Lesson",
    description:
      "One on one professional training sessions focused on skill development, technique mastery, and hands on learning for aspiring and advanced stylists.",
    services: [
      { name: "Beginner Level", price: 800 },
      { name: "Master Class", price: 500 },
    ],
  },
];
